/** @format */

export const LinkedinSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.8886 1.33331H4.11079C2.5769 1.33331 1.33301 2.5772 1.33301 4.11109V11.8889C1.33301 13.4228 2.5769 14.6666 4.11079 14.6666H11.8886C13.423 14.6666 14.6663 13.4228 14.6663 11.8889V4.11109C14.6663 2.5772 13.423 1.33331 11.8886 1.33331ZM5.77745 11.8889H4.11079V5.77776H5.77745V11.8889ZM4.94412 5.07331C4.40745 5.07331 3.9719 4.63442 3.9719 4.09331C3.9719 3.5522 4.40745 3.11331 4.94412 3.11331C5.48079 3.11331 5.91634 3.5522 5.91634 4.09331C5.91634 4.63442 5.48134 5.07331 4.94412 5.07331ZM12.4441 11.8889H10.7775V8.77553C10.7775 6.90442 8.55523 7.04609 8.55523 8.77553V11.8889H6.88856V5.77776H8.55523V6.75831C9.33079 5.32165 12.4441 5.21554 12.4441 8.13387V11.8889Z"
                fill={color}
            />
        </svg>
    );
};
